export const PermissionCode = {
  // Tất cả
  All: "All",
  // xem
  View: "View",
  // Thêm
  Add: "Add",
  // Sửa
  Update: "Update",
  // Xóa
  Delete: "Delete",
  // Xuất khẩu
  Export: "Export",
  //Nhập khẩu
  Import: "Import",
  //Toàn quyền
  FullPermission: "FullPermission",
  // không có quyền
  NoPermission: "NoPermission"
};
